// 2枚歩きの足滑りを薄める比較版 (2026-11-03・駅7 #4・DEV `?walkSurge=1`)。配布版は切 = 何も変わらない。
//   2枚歩き (walk_passing ↔ walk_reach をハードカット) は、1枚を出している間に体が半歩 (歩幅の半分) 等速で進む
//   = 床に着いた足が絵ごと床の上を滑る。介錯は「踏み込んで着地で止まる」一歩の絵で同じ傷を消した (src/exec_step_weight.ts)。
//   絵を足さずに同じ考えを入れる: 見た目の体だけ、絵が替わる瞬間に速く・1枚の真ん中でほぼ止まるよう速さを波打たせる。
//   速さ = 1 + A·cos(2πu) (u = 半歩の中の位置・0 = 絵が替わる瞬間)。平均の速さ・当たり・間合い (boss.x) は変えない。
//   見た目と boss.x のずれは最大 A·半歩/2π (半歩 65px・A 0.8 で約 8px)。
//   記録 = docs/research/2026-11-03-hound-foot-walk-surge.md
let surgeAmp = 0

export function setBossWalkSurge(v: string | null): void {
  surgeAmp = v === '1' ? 0.8 : 0
}

export function bossWalkSurgeEnabled(): boolean {
  return surgeAmp > 0
}

// 体を進む向きへ何 px ずらして描くか (正 = 進む向き)。
//   walkDist = 積算の移動量、stridePx = 歩き1サイクル。2枚の切り替えは walkDist/stride の 0.25 と 0.75 (sprites.ts の閾値 0.5)。
export function bossWalkSurgeOffsetPx(walkDist: number, stridePx: number, amp = surgeAmp): number {
  if (amp <= 0 || stridePx <= 0) return 0
  const half = stridePx / 2
  const u = (((((walkDist / stridePx) + 0.25) % 0.5) + 0.5) % 0.5) / 0.5
  return amp * half / (2 * Math.PI) * Math.sin(2 * Math.PI * u)
}
